import { createSvgIcon } from './utils';

export default createSvgIcon(
  <path d="M10.414 3l2 2H21c.552 0 1 .448 1 1v14c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h7.414zM13 9h-2v6h5v-2h-3V9z" />,
  'Record',
  '0 0 24 24'
);
